import {action} from 'easy-peasy';

interface SearchIndexData {
    id: string;
    name: string;
    status: string;
    created_at: string;
    updated_at: string;
}

interface SearchIndexStats {
    total_documents: number;
    total_size: number;
    last_updated: string;
}

interface SearchIndexMapping {
    properties: Record<string, any>;
    mappings: Record<string, any>;
}

interface SearchIndexState {
    items: SearchIndexData[];
    stats: SearchIndexStats[];
    status: boolean;
    loading: boolean;
    mapping: SearchIndexMapping;
    loadingMapping: boolean;
    paramsSetter: boolean;
    activeWord: string | null;
    headerActiveWord: string | null;
}

export default {
    items: [] as SearchIndexData[],
    loadSearchIndexData: action((state, searchIndexDataList: SearchIndexData[]) => {
        (state as any).items = searchIndexDataList;
    }),
    stats: [] as SearchIndexStats[],
    loadSearchIndexStats: action((state, searchIndexStatsList: SearchIndexStats[]) => {
        (state as any).stats = searchIndexStatsList;
    }),
    status: false,
    setStatus: action((state, status: boolean) => {
        (state as any).loading = status;
    }),
    loading: false,
    setLoading: action((state, loading: boolean) => {
        (state as any).loading = loading;
    }),

    mapping: {} as SearchIndexMapping,
    loadSearchIndexMapping: action((state, searchIndexMapping: SearchIndexMapping) => {
        (state as any).mapping = searchIndexMapping;
    }),
    loadingMapping: false,
    setLoadingMapping: action((state, loading: boolean) => {
        (state as any).loadingMapping = loading;
    }),

    paramsSetter: false,
    setParamsSetter: action((state) => {
        (state as any).paramsSetter = true;
    }),
    activeWord: null as string | null,
    setActiveWord: action((state, activeWord: string | null) => {
        (state as any).activeWord = activeWord;
    }),
    headerActiveWord: null as string | null,
    setHeaderActiveWord: action((state, headerActiveWord: string | null) => {
        (state as any).headerActiveWord = headerActiveWord;
    }),
};
